module.exports = __webpack_public_path__ + "img/landing.6e91ac7f.jpg";